function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from "react";

/**
 * Get react element type name.
 *
 * @param {React.ReactNode} element - React node. Can be children.
 * @returns {string} - React element name.
 */
export var getReactElementType = function getReactElementType(element) {
  var _element$type, _element$type2;
  return (element === null || element === void 0 || (_element$type = element.type) === null || _element$type === void 0 ? void 0 : _element$type.displayName) || (element === null || element === void 0 || (_element$type2 = element.type) === null || _element$type2 === void 0 ? void 0 : _element$type2.name) || (element === null || element === void 0 ? void 0 : element.type) || _typeof(element);
};

/**
 * Get React element according to its type name.
 *
 * @param element - React node. Can be children.
 * @param name - React name element.
 * @returns {React.ReactNode, undefined} Return matching react element or nothing.
 */
export var getReactElementByType = function getReactElementByType(element, name) {
  return React.Children.toArray(element).find(function (child) {
    return getReactElementType(child) === name;
  });
};

/**
 * Get a list of react element type name.
 *
 * @param children {React.ReactNode[]}
 * @returns {string[]} - List of react element type name.
 */
export var getReactChildrenTypes = function getReactChildrenTypes(children) {
  return React.Children.toArray(children).map(getReactElementType);
};